import {
  Button,
  Checkbox,
  Divider,
  Group,
  ScrollArea,
  Table,
  Text,
  TextInput,
} from "@mantine/core";
import { modelFilterHook } from "../../../../../../shared/utils/modelFilter";
import { IDevice } from "../types";
import { SelectAllRowsParams } from "../../../../../../shared/hook/useCheckbox";

const tableHead = ["번호", "MAC", "디바이스 종류", "S/N", "메모"];

interface IDeviceInfoSection {
  editId: number | null;
  openDeviceListModal: () => void;
  rows: IDevice[];
  onRemoveRow: (selectedId: Set<number>) => void;
  dispatchedDeviceDetail: IDevice;
  deviceCheckbox: {
    selectedIds: Set<number>;
    onSelectRow: (id: number) => void;
    onSelectAllRows: (params: SelectAllRowsParams<IDevice>) => void;
    setSelectedIds: (ids: Set<number>) => void;
  };
  isReady: boolean;
}

export default function DeviceInfoSection(props: IDeviceInfoSection) {
  const {
    editId,
    openDeviceListModal,
    rows,
    onRemoveRow,
    dispatchedDeviceDetail,
    deviceCheckbox,
    isReady,
  } = props;
  const { selectedIds, onSelectRow, onSelectAllRows, setSelectedIds } =
    deviceCheckbox;

  return (
    <>
      {!editId && (
        <>
          <div>
            <Text fw="bold">디바이스 정보 입력</Text>
            <Divider my="xs" />
            <Button onClick={openDeviceListModal} disabled={!isReady}>
              MAC번호 검색
            </Button>
          </div>
          {rows.length > 0 && (
            <>
              <Group justify="flex-end" mb="xs">
                <Button
                  variant="outline"
                  onClick={() => {
                    onRemoveRow(selectedIds);
                    setSelectedIds(new Set());
                  }}
                >
                  선택 삭제
                </Button>
              </Group>
              <ScrollArea.Autosize h={280}>
                <Table stickyHeader withTableBorder>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>
                        <Checkbox
                          checked={
                            selectedIds.size > 0 &&
                            selectedIds.size === rows.length
                          }
                          onChange={() =>
                            onSelectAllRows({
                              items: rows,
                              checked: selectedIds.size !== rows.length,
                            })
                          }
                        />
                      </Table.Th>
                      {tableHead.map((head) => (
                        <Table.Th key={head} align="center">
                          {head}
                        </Table.Th>
                      ))}
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {rows.map((row, index) => (
                      <Table.Tr key={row.id}>
                        <Table.Td>
                          <Checkbox
                            checked={selectedIds.has(row.id)}
                            onChange={() => onSelectRow(row.id)}
                          />
                        </Table.Td>
                        <Table.Td align="center">{index + 1}</Table.Td>
                        <Table.Td align="center">{row.mac}</Table.Td>
                        <Table.Td align="center">
                          {modelFilterHook(
                            row.deviceTypeCd,
                            row.deviceSubTypeCd
                          )}
                        </Table.Td>
                        <Table.Td align="center">{row.serialNumber}</Table.Td>
                        <Table.Td align="center">{row.memo}</Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.Tbody>
                </Table>
              </ScrollArea.Autosize>
            </>
          )}
        </>
      )}
      {editId && (
        <div>
          <Text fw="bold">디바이스 정보</Text>
          <Divider my="xs" />
          <TextInput
            value={dispatchedDeviceDetail.mac}
            readOnly
            disabled
            w={300}
          />
        </div>
      )}
    </>
  );
}
